var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"font-heading text-2xl mb-2 font-light"},[_vm._v("\n        Be the first to know\n    ")]),_vm._v(" "),_c('p',{staticClass:"text-xs mb-2"},[_vm._v("\n        Get all the latest information on Events,\n        Sales and Offers. Sign up for our newsletter today.\n    ")]),_vm._v(" "),_c('NewsletterSubscribe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }